import { useMemo } from 'react'
import styled from 'styled-components'
import { formatBottleSize } from 'utils/wine'

const Switcher = styled.fieldset`
  display: flex;
  flex-direction: row;
  padding: 4px;
  background: #fff;
  border: 1px solid #e7e7ea;
  border-radius: 8px;

  input {
    opacity: 0;
    position: absolute;
  }
`

const SwitcherOption = styled.label`
  flex: 1;
  position: relative;
  cursor: pointer;

  &:has(:focus-visible) {
    outline: -webkit-focus-ring-color auto 1px;
  }
`

const Label = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-radius: 4px;
  font: var(--typography-12-16-semibold);
  text-align: center;
  color: #121432;
  border: 1px solid transparent;
  user-select: none;

  input:checked + & {
    background: #f3f3f5;
    border-color: #e7e7ea;
  }
`

const KoefSelector = ({ bottleSize, onChange }) => {
  const items = useMemo(() => {
    const volumeML = bottleSize?.volumeML || 750

    const result = [{ k: 1, label: '100ML' }]

    if (volumeML !== 100) {
      result.push({
        k: volumeML / 100,
        label: formatBottleSize(volumeML),
      })
    }

    if (volumeML > 125) {
      result.push({ k: 1.25, label: '125ML' })
    }

    result.sort((a, b) => a.k - b.k)

    return result
  }, [bottleSize])

  const handleSelectKoef = e => {
    onChange(Number(e.target.value))
  }

  return (
    <Switcher onChange={handleSelectKoef}>
      {items.map(item => (
        <SwitcherOption key={item.k}>
          <input
            type='radio'
            name='volume'
            value={item.k}
            defaultChecked={item.k === 1}
          />
          <Label>{item.label}</Label>
        </SwitcherOption>
      ))}
    </Switcher>
  )
}

export default KoefSelector
